import React from "react";
import { UncontrolledTooltip } from "reactstrap";

import style from "./CompositionBar.scss";

const colors = {
  1: "color1",
  2: "color2",
  3: "color3",
  4: "color4",
  5: "color5",
  6: "color6",
};

export const CompositionBar = ({ data = [] }) => {
  let barColorIdx = 0;
  let pillColorIdx = 0;

  return (
    <div className={style.barWrapper}>
      <div className={style.bar}>
        {data.map((item, index) => {
          if (barColorIdx === 6) {
            barColorIdx = 1;
          }
          barColorIdx += 1;

          const tooltipIndex = `bar-${barColorIdx}`;
          return (
            <div
              key={"bar-" + item.name + "-" + index}
              id={tooltipIndex}
              className={`${style.item} ${style[colors[barColorIdx]]}`}
              style={{ width: item.percentage > 20 ? `${item.percentage}%` : "auto" }}
              //style={{width : `${item.percentage}%`}}
            >
              <UncontrolledTooltip
                placement="right"
                target={tooltipIndex}
                style={{ fontFamily: "Poppins", fontSize: 16 }}
              >
                {`${item.name}: ${item.percentage}%`}
              </UncontrolledTooltip>
              <span className={style.itemSpan}>{`${item.percentage}%`}</span>
            </div>
          );
        })}
      </div>
      <div className={style.details}>
        {data.map((item, index) => {
          if (pillColorIdx === 6) {
            pillColorIdx = 1;
          }
          pillColorIdx += 1;

          return (
            <div className={`${style.item}`} key={item.name + "-" + index}>
              <span className={`${style.pill} ${style[colors[pillColorIdx]]}`} />
              <div className={style.data}>
                <span className={style.name}>{item.name}</span>
                <span className={style.percentage}>{`${item.percentage}%`}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
